<template>
  <div class="bi-table-card bottom-box">
    <!-- <div class="bi-table-card--items">
      <div class="bi-table-card--item campaign-item">
        <div class="bi-table-card--item-details header-row">
          <p class="header bi-table-card--item-details-p font-bold">
            Benutzergruppe
          </p>
          <p class="header bi-table-card--item-details-p font-bold">Gesamt</p>
          <p
            v-for="(jobType, i) in jobTypes"
            :key="i"
            class="header bi-table-card--item-details-p font-bold"
          >
            {{ jobType }}
          </p>
        </div>
      </div>
      <template v-for="group in topUserGroups">
        <div
          v-if="group.UserGroupID"
          :key="group.UserGroupID"
          class="bi-table-card--item campaign-item"
        >
          <top-user-groups-inner
            :id="group.UserGroupID"
            :applications="group.Applications"
            :job-types="jobTypes"
            :by-job-type="group.ByJobType"
          />
        </div>
      </template>
      <div class="bi-table-card--item campaign-item">
        <div class="bi-table-card--item-details header-row">
          <p class="header bi-table-card--item-details-p">Alle</p>
          <p class="header bi-table-card--item-details-p">
            {{ allApplications }}
          </p>
          <p
            v-for="(jobType, i) in jobTypes"
            :key="i"
            class="header bi-table-card--item-details-p"
          >
            {{ allApplicationsForJobType(jobType) }}
          </p>
        </div>
      </div>
    </div> -->
    <table class="bi-dashboard-table">
      <thead>
        <tr>
          <th class="user-group">Benutzergruppe</th>
          <th>Gesamt</th>
          <th v-for="(jobType, i) in jobTypes" :key="i">
            {{ jobType }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="group in topUserGroups">
          <top-user-groups-inner
            v-if="group.UserGroupID"
            :id="group.UserGroupID"
            :key="group.UserGroupID"
            :applications="group.Applications"
            :job-types="jobTypes"
            :by-job-type="group.ByJobType"
          />
        </template>
        <tr>
          <th class="user-group">Alle</th>
          <th>{{ allApplications }}</th>
          <th v-for="(jobType, i) in jobTypes" :key="i">
            {{ allApplicationsForJobType(jobType) }}
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import gql from "graphql-tag";
import TopUserGroupsInner from "./TopUserGroupsInner.vue";

export default {
  components: { TopUserGroupsInner },
  props: ["startDate", "endDate", "number"],
  data() {
    return { topUserGroups: null, jobTypes: [] };
  },
  apollo: {
    topUserGroups: {
      query: gql`
        query topUserGroups($start: Time, $end: Time, $number: Int!) {
          topUserGroups(
            start: $start
            end: $end
            number: $number
            includeAll: true
          ) {
            Applications
            UserGroupID
            ByJobType
          }
        }
      `,
      variables() {
        return {
          start: this.startDate,
          end: this.endDate,
          number: this.number
        };
      }
    }
  },
  computed: {
    allApplications() {
      if (!this.topUserGroups) {
        return 0;
      }
      let total = 0;
      for (const userGroup of this.topUserGroups) {
        total += userGroup.Applications;
      }
      return total;
    }
  },
  watch: {
    topUserGroups(value) {
      let jobTypes = new Set();
      for (const userGroupData of value) {
        for (const jobType of Object.keys(userGroupData.ByJobType)) {
          jobTypes.add(jobType);
        }
      }
      this.jobTypes = [...jobTypes];
    }
  },
  methods: {
    allApplicationsForJobType(jobType) {
      if (!this.topUserGroups) {
        return 0;
      }
      let total = 0;
      for (const userGroup of this.topUserGroups) {
        total += userGroup.ByJobType[jobType] || 0;
      }
      return total;
    }
  }
};
</script>
<style scoped>
.header {
  width: 20%;
  color: #6e6b7b;
}
.header-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 3%;
}
</style>
